import React from 'react';
import PropTypes from 'prop-types';

import FeeGroupListItemTableRowWrapper from './FeeGroupListItemTableRowWrapper';

const FeeGroupListItemTable = ({ feeGroupData }) => {

  return (
    <React.Fragment>
      <table className="fee-listing-table table">
        <colgroup>
          <col className="col-5"></col>
          <col className="col-5"></col>
          <col className="col-12"></col>
          <col className="col-2"></col>
        </colgroup>
        <thead>
          <tr>
            <th>Fee Type</th>
            <th>Billing Category</th>
            <th>Fees</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <FeeGroupListItemTableRowWrapper
            feeGroupID={feeGroupData.id} feesData={feeGroupData.fees}
          />

        </tbody>
      </table>
    </React.Fragment>
  );
}

FeeGroupListItemTable.propTypes = {
  feeGroupData: PropTypes.shape({
    id: PropTypes.string
  })
};

export default FeeGroupListItemTable;